export const iconFontAwesomeEditingChartSimple = (
	<i className="fa-solid fa-chart-simple"></i>
);
